<template>
  <div v-if="loading" class="tw-flex tw-justify-center tw-py-8">
    <WdsSpinner :size="24" indeterminate />
  </div>
  <WdsStack v-else-if="applicableCompliances.length > 0" direction-column gap-md>
    <WdsText :text="$t('Staffing agency compliance')" secondary />

    <WdsStack direction-column data-test="compliance-rows">
      <ComplianceRow
        v-for="item in applicableCompliances"
        :key="item.name"
        :compliance="item.raw"
      />
    </WdsStack>
  </WdsStack>
  <WdsText v-else :text="$t('No compliances applicable')" secondary class="tw-text-center" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsSpinner, WdsStack, WdsText } from '@worksome/wds-components'
import { useQuery } from '@vue/apollo-composable'
import { useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { ComplianceName } from '@/gql/graphql'
import { COMPLIANCE_ROW_FRAGMENT } from '@/components/RecruiterDetailPanel/graphql/fragments'
import { RecruiterCompliancesQuery } from '@/components/RecruiterDetailPanel/graphql/queries'
import ComplianceRow from '@/components/RecruiterDetailPanel/PanelTabs/ComplianceRow.vue'

const RECRUITER_COMPLIANCES = [
  ComplianceName.RecruiterNlBusinessEntity,
  ComplianceName.NlWaadiRegistration,
  ComplianceName.NlKvkRegistration,
  ComplianceName.NlSnaCertification,
  ComplianceName.NlBtwIdentification,
  ComplianceName.NlInsurance,
  ComplianceName.NlGAccount,
]

const props = defineProps<{
  recruiterId: string
  companyRecruiterId: string
}>()

const complianceVariables = computed(() => ({
  recruiterId: props.recruiterId,
  names: RECRUITER_COMPLIANCES,
}))

const { loading, result: compliancesResult } = useQuery(
  RecruiterCompliancesQuery,
  complianceVariables,
  { clientId: 'publicApi' },
)

const compliances = computed(() => compliancesResult.value?.compliance ?? [])

const applicableCompliances = computed(() =>
  compliances.value
    .map((raw) => ({ raw, ...useFragment(COMPLIANCE_ROW_FRAGMENT, raw) }))
    .filter((c) => c.applicable),
)
</script>
